/* Header Vitalia — botón "Menú" / hamburguesa que abre el panel de productos.
   Réplica del <vitaly-header> de vitaly-chile.com + foco accesible, Esc, y soporte del editor de temas. */
if (!customElements.get('vitalia-header')) {
  class VitaliaHeader extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.vh-panel');
      this.toggles = Array.from(this.querySelectorAll('[data-vh-toggle]'));
      this.lastTrigger = null;

      this.toggles.forEach((btn) =>
        btn.addEventListener('click', () => {
          this.lastTrigger = btn;
          this.toggle();
        })
      );
      this.querySelectorAll('[data-vh-close]').forEach((el) => el.addEventListener('click', () => this.close()));

      this.onKeydown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close(true);
          return;
        }
        // Trampa de foco: Tab / Shift+Tab se quedan dentro del panel
        if (e.key === 'Tab' && this.panel) {
          const items = this.getFocusable();
          if (!items.length) return;
          const first = items[0];
          const last = items[items.length - 1];
          const inside = this.panel.contains(document.activeElement);
          if (e.shiftKey && (document.activeElement === first || !inside)) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && (document.activeElement === last || !inside)) {
            e.preventDefault();
            first.focus();
          }
        }
      };

      const drawerCart = this.querySelector('[data-vh-cart]');
      if (drawerCart) {
        drawerCart.addEventListener('click', () => {
          this.close();
          const cartIcon = document.getElementById('cart-icon-bubble');
          if (cartIcon) {
            cartIcon.click();
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
          }
        });
      }

      this.syncCartCount();

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => {
          if (this.contains(e.target)) this.open(false);
        };
        this.onBlockDeselect = (e) => {
          if (this.contains(e.target)) this.close();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    disconnectedCallback() {
      this.close();
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      if (this.cartObserver) this.cartObserver.disconnect();
    }

    isOpen() {
      return this.classList.contains('vh-open');
    }

    toggle() {
      this.isOpen() ? this.close(true) : this.open(true);
    }

    open(moveFocus = true) {
      if (this.isOpen()) return;
      document.documentElement.style.setProperty(
        '--vh-header-h',
        Math.max(0, this.querySelector('.vh-bar').getBoundingClientRect().bottom) + 'px'
      );
      // Evita el salto de layout al ocultar la barra de scroll
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
      document.body.style.overflow = 'hidden';

      this.classList.add('vh-open');
      this.toggles.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.addEventListener('keydown', this.onKeydown);

      if (moveFocus && this.panel) {
        // espera al cambio de visibility para poder enfocar
        requestAnimationFrame(() => {
          const focusTarget = this.getFocusable()[0] || this.panel;
          focusTarget.focus({ preventScroll: true });
        });
      }
    }

    close(returnFocus = false) {
      if (!this.isOpen()) return;
      this.classList.remove('vh-open');
      this.toggles.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.removeEventListener('keydown', this.onKeydown);

      const visibleTrigger =
        (this.lastTrigger && this.lastTrigger.offsetParent !== null && this.lastTrigger) ||
        this.toggles.find((b) => b.offsetParent !== null);
      if (returnFocus && visibleTrigger) visibleTrigger.focus();
    }

    getFocusable() {
      return Array.from(
        this.panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.getClientRects().length > 0 && el.getAttribute('tabindex') !== '-1');
    }

    syncCartCount() {
      const mainCart = this.querySelector('#cart-icon-bubble');
      const drawerCount = this.querySelector('[data-vh-cart-count]');
      if (!mainCart || !drawerCount) return;
      const sync = () => {
        const bubble = mainCart.querySelector('.cart-count-bubble span[aria-hidden]');
        const count = bubble ? bubble.textContent.trim() : '';
        drawerCount.textContent = count || '0';
        drawerCount.classList.toggle('is-hidden', !count || count === '0');
      };
      sync();
      this.cartObserver = new MutationObserver(sync);
      this.cartObserver.observe(mainCart, { childList: true, subtree: true, characterData: true });
    }
  }

  customElements.define('vitalia-header', VitaliaHeader);
}
